// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LIHNZ6U4NSm-Kw9zml2GX"};